export const FETCH_ERROR = 'Error fetching data';
export const CARBON_STATUS_ERROR = 'Error updating carbon status';
export const DOWNLOAD_ERROR = 'Error downloading data';
